// Stitches S2 (nxmonorepo todos/stitches-aziz-auto.md): with the tenant's
// product.optionalPurchasePrice flag on, new products are created without a purchase price (the
// API stores 0). Editing still shows the field, but it is optional. With the flag off, nothing
// changes.

export const optionalPurchasePriceFlag = 'product.optionalPurchasePrice';

export function shouldShowPurchasePriceColumn({
  formType,
  purchasesProduct,
  optionalPurchasePriceEnabled,
}: {
  formType: 'add' | 'edit';
  purchasesProduct: boolean;
  optionalPurchasePriceEnabled: boolean;
}): boolean {
  if (!purchasesProduct) return false;
  return !(formType === 'add' && optionalPurchasePriceEnabled);
}

export function isPurchasePriceRequired({
  optionalPurchasePriceEnabled,
}: {
  optionalPurchasePriceEnabled: boolean;
}): boolean {
  return !optionalPurchasePriceEnabled;
}

// A blank cell is allowed (and imported as 0) only when the flag is on; text is never allowed.
export function isValidImportPurchasePrice(
  rawValue: string | undefined,
  optionalPurchasePriceEnabled: boolean,
): boolean {
  const trimmedValue = (rawValue ?? '').trim();
  if (trimmedValue === '') return optionalPurchasePriceEnabled;
  return !Number.isNaN(Number(trimmedValue));
}
